import { Assessment, AssessmentType } from '@playbooks/core/src/interfaces/ActionCard'

function checkFirstResponseIfNeeded(assessmentItem: Assessment) {
  if (
    // The assessment has the autoSelectFirstChoice property enabled
    assessmentItem.autoSelectFirstChoice &&
    // No response is selected
    !assessmentItem.responses.some(resp => resp.checked) &&
    // The assessment is in the expanded state
    assessmentItem.checked &&
    // The assessment is not of the MULTI type
    assessmentItem.type !== AssessmentType.MULTI
  ) {
    if (assessmentItem.responses[0]) {
      assessmentItem.responses[0].checked = true
    }
  }

  // If an assessment is in the collapsed state then every its response must be unselected
  if (!assessmentItem.checked) {
    assessmentItem.responses.forEach(resp => {
      resp.checked = false
    })
  }
}

export default checkFirstResponseIfNeeded
